import React from 'react'
import Layout from '../../components/layout/Layout'
import CancelOrderTable from '../../elements/tables/cancel/CancelOrderTable'

export default function CancelOrders() {
  return (
    <div>
      <Layout>
        <CancelOrderTable />
      </Layout>
    </div>
  )
}
